import { Pipe, PipeTransform } from '@angular/core';
import { act, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { IntegrationType } from '@shared/enums/IntegrationType';
import { IActivityLogBase } from '@shared/services/activity-service/activity.models';
import { ActivityService } from '@shared/services/activity-service/activity.service';
import { IActivityLog as IEvnInvActivityLog } from '@shared/services/api/dashboard/invitations-service/invitations-model';

@Pipe({
  name: 'activityType'
})
export class ActivityTypePipe implements PipeTransform {
  constructor(
    private translation: TranslateService,
  ) { }

  // Use i18n currently loaded translation, since translations cannot be localized
  public currentLang = this.translation.currentLang;
  static activityPostFix = 'ACTIVITY'.length;
  public transform(activity: IActivityLogBase) {
    let value: string = null;
    const activityPostFixRemoved = activity.type.substring(0, activity.type.length - ActivityTypePipe.activityPostFix);
    const invActivity = activity as IEvnInvActivityLog;
    if (invActivity) {
      if (ActivityService.isConfirmedInvitationAndContactUpdated(invActivity)) {
        value = this.translation.instant('ACTIVITYLOG.TYPE.REGISTRATIONUPDATED');
        return value;
      }
      if (ActivityService.isOfExportType(activity)) {
        value = this.translation.instant('ACTIVITYLOG.TYPE.'+activityPostFixRemoved.toUpperCase());
        return value;
      }
      if (ActivityService.isOfMailType(invActivity)) {
        const typeOfMail = this.translation.instant('EVENTMAILTYPE.'+ invActivity.mailType);
        const typeOfActivity = this.translation.instant('ACTIVITYLOG.TYPE.SENDMAIL', { typeOfMail });
        return typeOfActivity;
      }
      if (activity.type?.toLowerCase()?.includes('userimport')) {
        const typeOfActivity = this.translation.instant('ACTIVITYLOG.TYPE.USERIMPORTEDINBATCH');
        return typeOfActivity;
      }
      if (activity.type?.toLowerCase()?.includes('contactimport')) {
        const typeOfActivity = this.translation.instant('ACTIVITYLOG.TYPE.CONTACTIMPORTEDINBATCH');
        return typeOfActivity;
      }
      if (activity.type?.toLowerCase()?.includes('invitationimport')) {
        let format = activity.displayable?.format ?? 'Excell';
        if(activity.displayable.crm === IntegrationType.Dynamics) {
          format = 'Marketing List';
        } else if(activity.displayable.crm === IntegrationType.Salesforce) {
          format = 'Campaign';
        }
        const typeOfActivity = this.translation.instant('ACTIVITYLOG.TYPE.INVITATIONIMPORTEDINBATCH', { format });
        return typeOfActivity;
      }
    }
    value = this.translation.instant('ACTIVITYLOG.TYPE.'+activityPostFixRemoved.toUpperCase());
    return value;
  }
}
